import React, { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  es: {
    nav: { explore: 'Explorar', admin: 'Administrar', cms: 'CMS', language: 'EN' },
    hero: {
      overline: 'CERRO DE LA PLATA PRESENTA',
      title: 'Kirei II',
      subtitle: 'Un nuevo concepto de vida en altura. 10 pisos de exclusividad, diseño y confort.',
      cta: 'Explorar Disponibilidad',
      scroll: 'Desplaza para descubrir'
    },
    building: {
      title: 'Selecciona un Piso',
      subtitle: 'Explora la disponibilidad de cada nivel',
      floor: 'Piso',
      units: 'unidades',
      unit: 'unidad',
      available: 'Disponible',
      reserved: 'Reservado',
      sold: 'Vendido',
      back: 'Volver',
      penthouse: 'Penthouse'
    },
    floorplan: {
      title: 'Planta del Piso',
      apartment: 'Apartamento',
      area: 'Superficie',
      price: 'Precio',
      bedrooms: 'Habitaciones',
      bathrooms: 'Baños',
      balcony: 'Balcón',
      orientation: 'Orientación',
      status: 'Estado',
      yes: 'Sí',
      no: 'No',
      backToBuilding: 'Volver al Edificio',
      reserve: 'Reservar',
      contact: 'Contactar',
      details: 'Ver Detalles'
    },
    admin: {
      title: 'Panel de Administración',
      login: 'Iniciar Sesión',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      loginBtn: 'Acceder',
      logout: 'Cerrar Sesión',
      stats: 'Estadísticas',
      total: 'Total',
      available: 'Disponibles',
      reserved: 'Reservados',
      sold: 'Vendidos',
      manageTitle: 'Gestión de Apartamentos',
      floor: 'Piso',
      unit: 'Unidad',
      status: 'Estado',
      price: 'Precio',
      area: 'Área',
      actions: 'Acciones',
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      welcome: 'Bienvenido'
    },
    cms: {
      title: 'Gestión de Contenido',
      siteSettings: 'Configuración del Sitio',
      apartments: 'Apartamentos',
      media: 'Medios',
      heroOverline: 'Subtítulo Hero',
      heroTitle: 'Título Hero',
      heroSubtitle: 'Descripción Hero',
      heroCta: 'Botón CTA',
      projectName: 'Nombre del Proyecto',
      contactPhone: 'Teléfono',
      contactEmail: 'Email de Contacto',
      contactAddress: 'Dirección',
      saveSettings: 'Guardar Configuración',
      saving: 'Guardando...',
      saved: 'Configuración guardada',
      editApartment: 'Editar Apartamento',
      description: 'Descripción',
      floorplanImage: 'Plano de Planta',
      galleryImages: 'Galería de Fotos',
      uploadFloorplan: 'Subir Plano',
      uploadPhoto: 'Subir Foto',
      removeImage: 'Eliminar',
      uploading: 'Subiendo...',
      uploaded: 'Archivo subido',
      spanish: 'Español',
      english: 'Inglés',
      back: 'Volver',
      selectApartment: 'Seleccionar apartamento para editar',
      noGalleryImages: 'Sin fotos de galería',
      currentFloorplan: 'Plano actual'
    }
  },
  en: {
    nav: { explore: 'Explore', admin: 'Admin', cms: 'CMS', language: 'ES' },
    hero: {
      overline: 'CERRO DE LA PLATA PRESENTS',
      title: 'Kirei II',
      subtitle: 'A new concept of elevated living. 10 floors of exclusivity, design and comfort.',
      cta: 'Explore Availability',
      scroll: 'Scroll to discover'
    },
    building: {
      title: 'Select a Floor',
      subtitle: 'Explore availability on each level',
      floor: 'Floor',
      units: 'units',
      unit: 'unit',
      available: 'Available',
      reserved: 'Reserved',
      sold: 'Sold',
      back: 'Back',
      penthouse: 'Penthouse'
    },
    floorplan: {
      title: 'Floor Plan',
      apartment: 'Apartment',
      area: 'Area',
      price: 'Price',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      balcony: 'Balcony',
      orientation: 'Orientation',
      status: 'Status',
      yes: 'Yes',
      no: 'No',
      backToBuilding: 'Back to Building',
      reserve: 'Reserve',
      contact: 'Contact',
      details: 'View Details'
    },
    admin: {
      title: 'Administration Panel',
      login: 'Log In',
      email: 'Email',
      password: 'Password',
      loginBtn: 'Sign In',
      logout: 'Log Out',
      stats: 'Statistics',
      total: 'Total',
      available: 'Available',
      reserved: 'Reserved',
      sold: 'Sold',
      manageTitle: 'Apartment Management',
      floor: 'Floor',
      unit: 'Unit',
      status: 'Status',
      price: 'Price',
      area: 'Area',
      actions: 'Actions',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      welcome: 'Welcome'
    },
    cms: {
      title: 'Content Management',
      siteSettings: 'Site Settings',
      apartments: 'Apartments',
      media: 'Media',
      heroOverline: 'Hero Overline',
      heroTitle: 'Hero Title',
      heroSubtitle: 'Hero Subtitle',
      heroCta: 'CTA Button',
      projectName: 'Project Name',
      contactPhone: 'Phone',
      contactEmail: 'Contact Email',
      contactAddress: 'Address',
      saveSettings: 'Save Settings',
      saving: 'Saving...',
      saved: 'Settings saved',
      editApartment: 'Edit Apartment',
      description: 'Description',
      floorplanImage: 'Floor Plan',
      galleryImages: 'Photo Gallery',
      uploadFloorplan: 'Upload Floor Plan',
      uploadPhoto: 'Upload Photo',
      removeImage: 'Remove',
      uploading: 'Uploading...',
      uploaded: 'File uploaded',
      spanish: 'Spanish',
      english: 'English',
      back: 'Back',
      selectApartment: 'Select an apartment to edit',
      noGalleryImages: 'No gallery photos',
      currentFloorplan: 'Current floor plan'
    }
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('es');
  const t = useCallback((path) => {
    const keys = path.split('.');
    let val = translations[lang];
    for (const k of keys) {
      val = val?.[k];
    }
    return val || path;
  }, [lang]);

  const toggleLang = () => setLang(l => l === 'es' ? 'en' : 'es');

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
